export default "__VITE_ASSET__CoQN21$k__"